import { render, staticRenderFns } from "./salary_advance.vue?vue&type=template&id=79f09fcf"
import script from "./salary_advance.vue?vue&type=script&lang=js"
export * from "./salary_advance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports